const autoNgTemplateLoaderTemplate1 = require('./groupForm.html');

import angular from 'angular';
import GroupFormController from './groupFormController';

angular.module('portainer.app').component('groupForm', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller: GroupFormController,
  bindings: {
    loaded: '<',
    pageType: '@',
    model: '=',
    availableEndpoints: '=',
    availableTags: '<',
    associatedEndpoints: '=',
    addLabelAction: '<',
    removeLabelAction: '<',
    formAction: '<',
    formActionLabel: '@',
    actionInProgress: '<',
    onCreateTag: '<',
  },
});
